const SelfServeBuilderToolboxConstants = {
  TOOLTIPS_HIDE: 'SELF_SERVE_BUILDER_TOOLBOX_TOOLTIPS_HIDE',
  ACTIVE_TOOLBOX_ITEM_SET: 'SELF_SERVE_BUILDER_TOOLBOX_ACTIVE_TOOLBOX_ITEM_SET',
};

export default SelfServeBuilderToolboxConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/SelfServeBuilderToolboxConstants.jsx